<template>
  <div class="sonar-answer-textbox">
    <div
      :key="`answer-id-${currentQuestion.uuid || currentQuestion.question_id}`"
    >
      <div class="sonar-answer-textbox__input-container">
        <div class="sonar-answer-textbox__dynamic-layout-submit"></div>
        <input
          ref="answer"
          v-model="userAnswer"
          type="text"
          :class="[
            'sonar-answer-textbox__input',
            showCorrectAnswer && 'sonar-answer-textbox__input--correct-answer',
          ]"
          placeholder="Your answer"
          :disabled="isDisabled"
        />
      </div>
      <div class="sonar-answer-textbox__submitted-container"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SonarAnswerTextbox',
  props: {
    currentQuestion: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: true,
    },
    correctTextAnswer: {
      type: String,
      required: false,
      default: '',
    },
    displayCorrectAnswers: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      userAnswer: '',
      isCorrectAnswer: false,
    }
  },
  computed: {
    showCorrectAnswer() {
      return this.displayCorrectAnswers && this.isCorrectAnswer
    },
  },
  watch: {
    userAnswer() {
      this.isCorrectAnswer =
        this.correctTextAnswer && this.correctTextAnswer === this.userAnswer
      this.$emit('update-selection', this.userAnswer)
    },
    currentQuestion() {
      this.userAnswer = ''
      this.setCorrectAnswer()
    },
    displayCorrectAnswers() {
      this.userAnswer = this.displayCorrectAnswers ? this.correctTextAnswer : ''
    },
  },
  created() {
    this.setCorrectAnswer()
  },
  methods: {
    setCorrectAnswer() {
      if (!this.correctTextAnswer || !this.displayCorrectAnswers) return
      this.isCorrectAnswer = true
      this.userAnswer = this.correctTextAnswer
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-answer-textbox {
  &__input {
    $input: &;
    &-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 20px;
      transition: all 0.6s ease-out;
      opacity: 1;
      z-index: 1;
      &--hide {
        opacity: 0;
        z-index: -1;
        pointer-events: none;
      }
      button {
        width: fit-content;
      }
    }
    width: 100%;
    padding: 15px 10px;
    border-radius: 5px;
    background: var(--darker-gray);
    color: var(--white);
    // TODO: this could be a mixin for text input
    border: 1px solid var(--emperor-gray);
    box-sizing: border-box;
    box-shadow: var(--gray-light-box-shadow);

    &:focus {
      color: var(--light-blue-gray);
      box-shadow: var(--purple-dark-box-shadow);
      &#{$input}--error {
        box-shadow: var(--carnation-box-shadow);
        filter: var(--gray-light-box-shadow-filter);
      }
    }
    &:disabled {
      background: var(--darker-gray);
      border: 1px solid var(--flat-black);
      box-sizing: border-box;
      box-shadow: var(--gray-light-box-shadow);
      color: var(--tundora-gray);
    }
    &--error {
      box-shadow: var(--carnation-box-shadow);
      filter: var(--gray-light-box-shadow-filter);
    }
    &--correct-answer {
      background: var(--positive-light-20);
      outline: solid !important;
      outline-width: 2px !important;
      outline-color: var(--positive-light) !important;
    }
  }
  &__button {
    &--hidden {
      display: none;
    }
  }
  &__submitted {
    &-container {
      width: 100%;
      height: 65px;
      border-radius: 10px;
      background: var(--glass-mid-gray);
      padding: 20px;
      position: relative;
      top: -56px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      transition: opacity 0.6s ease-out;
      opacity: 0;
      z-index: -1;
      &--dynamic-field {
        top: -128px;
      }
      &--show {
        opacity: 1;
        z-index: 1;
      }
      &--replace {
        top: 0;
      }
    }
    &-pill {
      width: 80px;
      color: var(--charcoal);
      text-align: center;
      padding: 5px;
      font-weight: 450;
      font-size: 12px;
      line-height: 14px;
      // TODO: this could be a mixin for all purple pills
      background: var(--purple-light);
      box-shadow: var(--purple-light-box-shadow);
      border-radius: 30px;
    }
    &-answer {
      display: flex;
      align-items: center;
      &-text {
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        margin-left: 10px;
      }
    }
  }
}
</style>
